export default __webpack_public_path__ + "static/media/fa-th.65dad993.jpg";